import React from 'react';
import { C } from '../constants';
import SeguimientoPagos from './SeguimientoPagos';
import FacturacionSiigo from './FacturacionSiigo';
import CentroCosto from './CentroCosto';

/**
 * PAGOS Y FACTURACIÓN — una sola pestaña.
 *
 * Antes esto estaba partido: la parte fiscal vivía en «Facturación DIAN» y el seguimiento del cobro
 * no existía como pantalla (había que leerlo pedido por pedido, o en `healthz`). El dueño no tiene
 * dos trabajos —cobrar y facturar—, tiene uno: que la plata entre y quede documentada. Por eso van
 * juntos, en este orden:
 *
 *   1. SEGUIMIENTO DE PAGOS — la flota: qué se cobró y en qué estado fiscal quedó, con lo cobrado y
 *      sin factura resaltado. Es lo que faltaba y va primero porque es lo que hay que vigilar.
 *   2. FACTURACIÓN (Siigo) — el motor de la suite, la cadena automática, el catálogo real de la
 *      cuenta, la lista de documentos y el emisor por pedido. Ya existía, sin duplicarse: el estado
 *      del motor y la cola siguen siendo su fuente única.
 *   3. CENTRO DE COSTO 225 — lo que Siigo tiene en el centro de Solar Hub, leído de root (26-oct-2026:
 *      «cada app debe manejar su centro de costos en su respectivo admin»).
 *
 * Van en SUB-PESTAÑAS, una a la vez (dueño, 25-oct, sobre la misma pantalla de FluxAI: «se debe
 * desplegar en más pestañas, muy largo»). La elegida se recuerda en este navegador.
 *
 * No hay un tercer semáforo de «estado del cobro» propio: el de `FacturacionSiigo` (motor + Siigo)
 * manda, para no repetir una bandera que ya se sabe que puede mentir si se declara dos veces.
 */

const SUBS = [
  ['seguimiento', 'Seguimiento de pagos'],
  ['facturacion', 'Facturación (Siigo)'],
  ['centro', 'Centro de costo'],
];
const CLAVE = 'sh:admin.pagos.sub';

function subGuardada() {
  try {
    const v = localStorage.getItem(CLAVE);
    return SUBS.some(([id]) => id === v) ? v : SUBS[0][0];
  } catch { return SUBS[0][0]; }
}

export default function PagosFacturacion() {
  const [sub, setSub] = React.useState(subGuardada);
  const elegir = (id) => {
    setSub(id);
    try { localStorage.setItem(CLAVE, id); } catch { /* sin storage: solo no se recuerda */ }
  };

  return (
    <div style={{ display: 'grid', gap: 14 }}>
      <div style={{ borderLeft: `3px solid ${C.teal}`, paddingLeft: 12 }}>
        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 800, color: C.heading }}>Pagos y Facturación</h2>
        <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>
          Todo lo que se cobra y todo lo que se factura, en un solo lugar. Una cuenta Siigo para todo Alebas.
        </div>
      </div>

      <div role="tablist" style={{ display: 'inline-flex', justifySelf: 'start', gap: 3, flexWrap: 'wrap', background: `${C.muted}14`, border: `1px solid ${C.border}`, borderRadius: 10, padding: 4 }}>
        {SUBS.map(([id, l]) => {
          const on = sub === id;
          return (
            <button key={id} type="button" role="tab" aria-selected={on} onClick={() => elegir(id)} style={{
              padding: '6px 13px', border: 'none', borderRadius: 7,
              background: on ? C.teal : 'transparent', color: on ? '#fff' : C.muted,
              cursor: 'pointer', fontSize: 12, fontWeight: on ? 700 : 500, whiteSpace: 'nowrap',
            }}>{l}</button>
          );
        })}
      </div>

      {sub === 'seguimiento' && <SeguimientoPagos />}
      {sub === 'facturacion' && <FacturacionSiigo />}
      {sub === 'centro' && <CentroCosto />}
    </div>
  );
}
